
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","viewBox":"0 0 19 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.137 9.252l-.543.572v7.016c0 .374.113.736.32 1.041.106.158.34.158.447 0 .206-.305.32-.667.32-1.04V9.823l-.544-.572z"}}),_c('path',{attrs:{"d":"M8.594 7.678v2.146c.178.018.36 0 .543 0 .183 0 .365.018.543 0V7.678H8.594z"}}),_c('path',{attrs:{"d":"M9.14 0v8.765A4.382 4.382 0 009.14 0z"}}),_c('path',{attrs:{"d":"M12.436 4.382C12.436 1.962 10.96 0 9.14 0a4.382 4.382 0 000 8.765c1.82 0 3.296-1.962 3.296-4.383z"}})])
          )
        }
      }
    